import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { ShareClassConversionCalculator } from '@/components/ledger/ShareClassConversionCalculator';
import { useTenantStore } from '@/hooks/useTenantStore';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Info } from 'lucide-react';

export default function ShareClassConversion() {
  const { tenantId } = useTenantStore();

  if (!tenantId) {
    return (
      <DashboardLayout>
        <Alert>
          <Info className="h-4 w-4" />
          <AlertTitle>No Company Selected</AlertTitle>
          <AlertDescription>
            Please select a company to use the share class conversion calculator.
          </AlertDescription>
        </Alert>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Share Class Conversion</h1>
          <p className="text-muted-foreground mt-1">
            Model the impact of converting preferred shares to common shares
          </p>
        </div>

        <ShareClassConversionCalculator companyId={tenantId} />
      </div>
    </DashboardLayout>
  );
}
